import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    lang: !!state.authReducer.lang ? state.authReducer.lang : "lang",
  };
}

const withLang = connect(mapStateToProps, null);

export { withLang };
